module.exports = __webpack_public_path__ + "static/media/vf_wknit_core.eff14d02.svg";